import {combineReducers} from "redux";
import StatesReducer from "./states/StatesReducer";
import SignUpReducer from "./auth/SignUpReducer";
import SchedulerReducer from "./scheduler/SchedulerReducer";
import PlansReducer from "./plans/PlansReducer";
import LocationReducer from "./location/location-reducer";

const RootReducer = combineReducers({
    states: StatesReducer,
    signUp: SignUpReducer,
    scheduler: SchedulerReducer,
    plans: PlansReducer,
    location: LocationReducer
});

export default RootReducer;
